import { useEffect, useState } from 'react';
import { PaymentRecord } from '../pages/hospital/Billing/types';
import { InsuranceClaim } from '../pages/hospital/InsuranceClaims/types';
import { getBillByUuidService } from '../services/billing';
import { InsuranceClaimsApiService } from '../pages/hospital/InsuranceClaims/services/insuranceClaimsApi';

interface UseBillPaymentDataResult {
  paymentRecords: PaymentRecord[];
  pec: InsuranceClaim;
}

function getDefaultInsuranceClaim(billTotal: number): InsuranceClaim {
  return {
    id: -1,
    uuid: '',
    organizationName: '',
    coveragePercentage: 0,
    requestedAmount: 0,
    approvedAmount: 0,
    guaranteeLetterNumber: '',
    guaranteeLetterIssueDate: new Date(),
    interventionDate: undefined,
    amountInLetters: '',
    guaranteeLetterPdfPath: '',
    approvalLetterImagePath: '',
    status: 'DRAFT',
    claimReference: '',
    notes: '',
    billId: -1,
    insuranceId: -1,
    baseAmount: billTotal,
    createdAt: new Date(),
    updatedAt: new Date(),
  };
}

export function useBillPaymentData(
  uuidInvestigation?: string,
  uuidBill?: string,
  billTotal?: number
): UseBillPaymentDataResult {
  const [paymentRecords, setPaymentRecords] = useState<PaymentRecord[]>([]);
  const [pec, setPec] = useState<InsuranceClaim>(getDefaultInsuranceClaim(billTotal || 0));

  useEffect(() => {
    if (uuidInvestigation && uuidBill) {
      getBillByUuidService(uuidInvestigation, uuidBill)
        .then((response) => {
          setPaymentRecords((response.bill as any).paymentRecords || []);
        })
        .catch(() => setPaymentRecords([]));

      const apiService = new InsuranceClaimsApiService();
      apiService.getClaimsForBill(uuidInvestigation, uuidBill)
        .then((claims) => {
          if (claims && claims.length > 0) {
            setPec(claims[0]);
          } else {
            setPec(getDefaultInsuranceClaim(billTotal || 0));
          }
        })
        .catch(() => setPec(getDefaultInsuranceClaim(billTotal || 0)));
    } else if (billTotal !== undefined) {
      setPec(getDefaultInsuranceClaim(billTotal));
    }
  }, [uuidInvestigation, uuidBill, billTotal]);

  return { paymentRecords, pec };
} 